import { combineReducers } from 'redux'
import messaging from './messaging'
//import todos from './todos'
import client from './client'
import member from './member'
import searchResults from './searchResults'
import register from './register'
//import auth from '../medefy-core/build/auth/reducers'
import auth from './auth';
import geolocation from './geolocation'
import environment from './environment'

//import members from './members'



const thisApp = combineReducers({
  messaging,
  client,
  member,
  searchResults,
  environment,
  auth,
  geolocation,
  register,
})

export default thisApp;


// export function getStep(state, action){
//   switch (action.type) {
//     case 'NEXT_STEP':
//       return {
//         ...state,
//         step: state.messaging.stepIndex + 1
//       }
//     case 'PREV_STEP':
//       return {
//         ...state,
//         step: state.messaging.stepIndex - 1
//       }
//     default:
//       return initialState;
//   }
// }

// const getMessaging = (state, action) => {
//   return state;
// }



// export default combineReducers({
//   getStep
// })




// WEBPACK FOOTER //
// ./src/reducers/index.js